import { BaseEntityDto, DvirStatusEnum, DvirTypeEnum, GetManyV2Dto } from '@fleet-beat/core';

export interface DvirDto extends BaseEntityDto {
  id?: string;
  driverId?: string;
  truckId?: string;
  trailerId?: string;
  type?: DvirTypeEnum;
  status?: DvirStatusEnum;
  title?: 'DVIR#8';
  notes?: string;
  odometer?: number;
  lat?: number;
  lon?: number;
  address?: string;
  date?: string;
  url?: string;
  driverSignatureUrl?: string;
  mechanicSignatureUrl?: string;
}

export interface GetDvirParams extends GetManyV2Dto {
  types?: DvirTypeEnum;
  statuses?: string;
  driverIds?: string;
  truckIds?: string;
  trailerIds?: string;
  date?: string;
  createdAt?: string;
}
